import { VGDisclaimerContent } from '../../../../components/VGDisclaimerContent/VGDisclaimerContent';
import { FunctionComponent } from 'react';
import { useStreetPageQuery } from '../../../graphql/useStreetPageQuery';

export const StreetPageVGDisclaimerModalContentWithData: FunctionComponent = () => {
  const vgDisclaimerHtml = useStreetPageQuery()?.data?.streetPageBySlug?.vgDisclaimerHtml;

  return <VGDisclaimerContent vgDisclaimerHtml={vgDisclaimerHtml ?? null} />;
};
